(function () {
  var modal = document.querySelector('[data-video-modal]');
  if (!modal) return;

  var content = modal.querySelector('[data-video-modal-content]');
  var lastTrigger = null;

  function openModal(template, trigger) {
    lastTrigger = trigger;
    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));

    modal.hidden = false;
    document.body.style.overflow = 'hidden';

    var video = content.querySelector('video');
    if (video) {
      video.play().catch(function () {
        /* autoplay might be blocked, that's fine, controls are visible */
      });
    }

    var closeBtn = modal.querySelector('[data-video-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var video = content.querySelector('video');
    if (video) {
      video.pause();
    }
    content.innerHTML = '';
    modal.hidden = true;
    document.body.style.overflow = '';

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-video-modal-trigger]');
    if (trigger) {
      if (trigger.disabled) return;
      var item = trigger.closest('.video-grid__item');
      var template = item && item.querySelector('[data-video-modal-template]');
      if (template) {
        openModal(template, trigger);
      }
      return;
    }

    if (event.target.closest('[data-video-modal-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
})();
